import { render } from "./svg.vue?vue&type=template&id=5cb684b4&scoped=true"
import script from "./svg.vue?vue&type=script&lang=js"
export * from "./svg.vue?vue&type=script&lang=js"

import "./svg.vue?vue&type=style&index=0&id=5cb684b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb684b4"]])

export default __exports__